/* eslint-disable */
import React, { Component } from 'react';
import ReactDOM from 'react-dom';

export default class PopupHeader extends Component {
    render() {
        const onDismiss = this.props.onDismiss ? this.props.onDismiss : null;
        return (
            <div className="popup-header">
                {this.props.onDismiss ? (
                    <div
                        className="popup-header-dismiss"
                        onClick={this.props.onDismiss}
                    >
                        <i className="icon icon-close" />
                    </div>
                ) : null}
                <h1>{this.props.title}</h1>
                <h2>{this.props.subtitle}</h2>
            </div>
        );
    }
}
